/* eslint-disable @fullstory/annotate-react/data-component */
import React from 'react';
import { Column } from './types';

export function useTableHeadCells<R>(
  Component: React.ComponentType<{ column: Column<R> } & any>,
  columns: Column<R>[],
  props: { [key: string]: any },
) {
  return columns.map((column, i) => {
    const { key } = column;
    return (
      <Component
        column={column}
        key={key}
        firstColumn={i === 0}
        lastColumn={i === columns.length - 1}
        {...props}
      />
    );
  });
}
